<template>
  <div v-if="items" class="meta-block-wrapper" :class="theme">
    <div v-for="(item, idx) in items" :key="idx" class="block-item">
      <base-svg v-if="item.icon" :svg="item.icon" height="35px" />
      <span v-html="item.content"></span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      theme: {
        type: String,
        default: null
      },

      items: {
        type: Array,
        default: null
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5.scss';

  .meta-block-wrapper {
    display: flex;
    border-radius: 10px;
    width: 100%;
    backdrop-filter: blur(10px);
    border: 1px solid rgba($yellow-tone-4, 0.1);
    background: rgba($yellow-tone-4, 0.03);
    color: $yellow-tone-4;

    .darkmode & {
      border-color: rgba($yellow-tone-3, 0.1);
      background: rgba($yellow-tone-3, 0.03);
      color: $yellow-tone-3;
    }

    .block-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 0.75rem;
      padding: 25px 20px;
      width: 100%;

      span {
        display: block;
      }

      svg {
        fill: $yellow-tone-4;

        .darkmode & {
          fill: $yellow-tone-3;
        }
      }

      &:not(:last-child) {
        border-right: 1px solid rgba($yellow-tone-4, 0.1);

        .darkmode & {
          border-right: 1px solid rgba($yellow-tone-3, 0.1);
        }
      }
    }

    &.locales {
      border-color: rgba($blue-tone-3, 0.1);
      background: rgba($blue-tone-3, 0.03);
      color: $blue-tone-3;

      .darkmode & {
        border-color: rgba($locales-tone, 0.1);
        background: rgba($locales-tone, 0.03);
        color: $locales-tone;
      }

      .block-item {
        svg {
          fill: $blue-tone-3;

          .darkmode & {
            fill: $locales-tone;
          }
        }

        &:not(:last-child) {
          border-right: 1px solid rgba($blue-tone-3, 0.1);

          .darkmode & {
            border-right: 1px solid rgba($locales-tone, 0.1);
          }
        }
      }
    }

    &.topics {
      border-color: rgba($green-tone-3, 0.1);
      background: rgba($green-tone-3, 0.03);
      color: $green-tone-3;

      .darkmode & {
        border-color: rgba($topics-tone, 0.1);
        background: rgba($topics-tone, 0.03);
        color: $topics-tone;
      }

      .block-item {
        svg {
          fill: $green-tone-3;

          .darkmode & {
            fill: $topics-tone;
          }
        }

        &:not(:last-child) {
          border-right: 1px solid rgba($green-tone-3, 0.1);

          .darkmode & {
            border-right: 1px solid rgba($topics-tone, 0.1);
          }
        }
      }
    }

    &.time {
      border-color: rgba($yellow-tone-4, 0.1);
      background: rgba($yellow-tone-4, 0.03);
      color: $yellow-tone-4;

      .darkmode & {
        border-color: rgba($time-tone, 0.1);
        background: rgba($time-tone, 0.03);
        color: $time-tone;
      }

      .block-item {
        svg {
          fill: $yellow-tone-4;

          .darkmode & {
            fill: $time-tone;
          }
        }

        &:not(:last-child) {
          border-right: 1px solid rgba($yellow-tone-4, 0.1);

          .darkmode & {
            border-right: 1px solid rgba($time-tone, 0.1);
          }
        }
      }
    }

    &.pro {
      border-color: rgba($green-tone-3, 0.1);
      background: rgba($green-tone-3, 0.03);
      color: $green-tone-3;

      .block-item {
        svg {
          fill: $green-tone-3;
        }

        &:not(:last-child) {
          border-right: 1px solid rgba($green-tone-3, 0.1);
        }
      }
    }
  }
</style>